define('productOptions/productOptions',[
    "common/urlUtils",
    "mediaGallery/mediaGallery",
    "productDetailsAndDimensions/productDetailsAndDimensions",
    "shoppingCartIcon/shoppingCartIcon",
    "shoppingCartIcon/miniCart",
    "common/alertMessage",
    "productDescriptionTabs/replacementParts",
    "common/spinner",
    "common/formUtils",
    "common/formatter"
],
function (urlUtils, mediaGallery, productDetailsAndDimensions, shoppingCartIcon, miniCart,
    alertMessage, replacementParts, spinner, formUtils, formatter) {

    // There can be multiple product options components on the same page.
    // productOptions global array will contain data for all of them.
    // optionsIndex variable always needs to point to the one that we're currently doing something with, so
    // all functions in this module can use it to get the options for the correct options component instance.
    // Each event handler will set that variable to the correct value (because in the event we know inside
    // of which product options component instance the event was fired), and the rest of the functions called
    // as a result of that event will then use it.
    // On initializations we run through all the product options component instances that exist on the page and
    // initialize them one by one in the loop, setting the correct value for optionsIndex variable for each step
    // of the loop.
    var optionsIndex = 0;
    function optionsSelector() {
        // this functions gives us the current product options selector
        return "#product_options_" + optionsIndex;
    }
    const allProductOptionsSelector = "[id^=product_options_]";

    const quantityInputSelector = " .quantity-selector input";

    function productOptionsElement(childElement) {
        poElement = $(childElement).closest(allProductOptionsSelector);
        return poElement.length ? poElement : null;
    }

    function init() {
        initEventHandlers();

        $(allProductOptionsSelector).each(function (i, element) {
            optionsIndex = $(element).data("optionsIndex");
            disableImpossibleCombinations();
            displayCurrentVariant(true);
            // To prevent flashing of some options that will initially be hidden, we keep
            // the options section hidden until we do initial setup of options.
            // Now we're ready to show it
            $(optionsSelector() + " .options").removeClass("d-none");
        });
    }


    function initEventHandlers() {
        // there are 3 types of option selector elements:
        $(allProductOptionsSelector+" button.option-value").off("click").on("click", buttonOptionClicked);           // a set of buttons
        $(allProductOptionsSelector+" .selector.option-value").off("click").on("click", buttonOptionClicked);        // color selector (or any other type of custom selector)
        $(allProductOptionsSelector+" select.option-value").off("change").on("change", listOptionChanged);             // a list
        // and there are also som buttons:
        $(allProductOptionsSelector + " button.cart").off("click").on("click", addToCartClicked);
        $(allProductOptionsSelector + " button.update").off("click").on("click", updateCartClicked);
        $(allProductOptionsSelector + quantityInputSelector).off("quantityChanged").on("quantityChanged", quantityChanged);
        $(allProductOptionsSelector + " button.remove-item").off("click").on("click", removeClicked);

    }

    function buttonOptionClicked(event) {
        if ($(this).hasClass("current")) return;   // already selected

        optionsIndex = $(this).closest(allProductOptionsSelector).data("optionsIndex");
        var optionData = $(this).data();
        changeVariant(optionData.fieldName, optionData.valueId);
    }

    function listOptionChanged(event) {
        optionsIndex = $(this).closest(allProductOptionsSelector).data("optionsIndex");
        var optionData = $(this.selectedOptions[0]).data();
        changeVariant(optionData.fieldName, optionData.valueId);
    }

    function updateCartClicked(event) {
        optionsIndex = $(this).closest(allProductOptionsSelector).data("optionsIndex");
        dispatchEvent("updateCart", {
            oldVariantGuid: productOptions[optionsIndex].initialVariantGuid,
            oldQuantity: productOptions[optionsIndex].initialQuantity,
            newVariantGuid: productOptions[optionsIndex].currentVariant.variantGuid,
            newProductSku: productOptions[optionsIndex].productSku,
            newVariantSku: productOptions[optionsIndex].currentVariant.variantSku,
            newQuantity: $(optionsSelector() + quantityInputSelector).val()
        });
    }

    function removeClicked(event) {
        optionsIndex = $(this).closest(allProductOptionsSelector).data("optionsIndex");
        elementForEvent = $(optionsSelector()).parent();
        $(optionsSelector()).remove();
        dispatchEvent("itemRemoved", {
            productSku: productOptions[optionsIndex].productSku,
            variantSku: productOptions[optionsIndex].currentVariant.variantSku
        },
        elementForEvent);
    }

    function changeVariant(fieldName, newValueId) {
        // change selected option value
        var optionToChange = productOptions[optionsIndex].currentVariant.options.find(function (option) {
            return option.fieldName === fieldName;
        });
        optionToChange.valueId = newValueId;

        identifyVariant(fieldName);

        disableImpossibleCombinations();

        displayCurrentVariant();
    }

    function disableImpossibleCombinations() {
        enableAllValues();
        // go through all possible combinations of option values and disable the values that lead to impossible combinations

        // outer loop goes through each option one by one
        productOptions[optionsIndex].options.forEach(function (option) {

            if (option.canBeDisabled) {

                // then this loop goes through all the values in that option one by one
                option.values.forEach(function (value) {

                    // this value goes as first into the combination to be tested
                    var combinationToTest = [{ fieldName: option.fieldName, valueId: value.valueId }];

                    // add the values that are currently selected for other options into the combination to be tested
                    productOptions[optionsIndex].currentVariant.options
                        .filter(function (o) { return o.fieldName !== option.fieldName; })
                        .forEach(function (otherOption) {
                            combinationToTest.push({
                                fieldName: otherOption.fieldName,
                                valueId: otherOption.valueId
                            });
                        });

                    // now we test if that combination makes up a valid variant
                    var variant = findVariant(combinationToTest);
                    if (!variant) {
                        // This is an impossible combination. Disable this value.
                        disableValue(value.valueId);
                    }
                });

            }

        });

        // hide option names that are left empty (with no values displayed under them)
        $(optionsSelector() + " .option .option-values").siblings(".option-name").addClass("hidden");  // hide all
        $(optionsSelector() + " .option .option-values").has(".option-value:not(.disabled, .d-none)").siblings(".option-name").removeClass("hidden");   // bring back only those that have at least one value displayed
    }

    function enableAllValues() {
        $(optionsSelector()+" button.option-value").removeClass("disabled");
        $(optionsSelector()+" .selector.option-value").removeClass("disabled");
        $(optionsSelector() + " select.option-value option").attr("hidden", null);
        $(optionsSelector() + " select.option-value option").attr("disabled", null);
    }

    function disableValue(valueId) {
        $(optionsSelector()+" button.option-value[data-value-id='" + valueId + "']").addClass("disabled");
        $(optionsSelector()+" .selector.option-value[data-value-id='" + valueId + "']").addClass("disabled");
        $(optionsSelector()+" select.option-value option[data-value-id='" + valueId + "']").attr("hidden", "");   // in the list we're hiding the option instead of disabling it
        $(optionsSelector()+" select.option-value option[data-value-id='" + valueId + "']").attr("disabled", "");   // also disable for IE
    }

    function markCurrentOptions(variantOptions) {
        // first unmark all
        $(optionsSelector()+" button.option-value").removeClass("current");
        $(optionsSelector() + " .selector.option-value").removeClass("current");
        $(optionsSelector() + " select.option-value option").removeClass("current");
        // print layout fields
        $(optionsSelector() + " .option.print-only").removeClass("d-print-block");  // hide all by default
        $(optionsSelector() + " .option.print-only .display-value").text("");  // and empty them
        // then mark those that need to be marked
        variantOptions.forEach(function (option) {
            $(optionsSelector()+" button.option-value[data-value-id='" + option.valueId + "']").addClass("current");
            $(optionsSelector()+" .selector.option-value[data-value-id='" + option.valueId + "']").addClass("current");
            $(optionsSelector() + " select.option-value:has(option[data-value-id='" + option.valueId + "'])").val(option.valueId);
            $(optionsSelector() + " select.option-value option[data-value-id='" + option.valueId + "']").addClass("current");
            // and set display values for print layout (only those that have values)
            if (option.displayValue) {
                var printOnlyElement = $(optionsSelector() + " .option.print-only[data-field-name='" + option.fieldName + "']");
                if (printOnlyElement) {
                    $(printOnlyElement).addClass("d-print-block");  // display the element
                    $(printOnlyElement).find(".display-value").text(option.displayValue);   // set value
                }
            }
        });
    }

    function identifyVariant(clickedFieldName) {
        // first try to find a variant that exactly matches the current set of chosen options
        var variant = findVariant(productOptions[optionsIndex].currentVariant.options);
        if (variant) {
            // We've found it! Just set its variantGuid and sku (the changed option is already set in changeVariant function).
            productOptions[optionsIndex].currentVariant.variantGuid = variant.variantGuid;
            productOptions[optionsIndex].currentVariant.variantSku = variant.variantSku;
        }
        else {
            // Find a variant that most closely matches the current set of chosen options.
            var rankingList = [];
            productOptions[optionsIndex].variants.forEach(function (variant) {
                var matchCount = 0;
                var clickedMatchCount = 0;
                variant.options.forEach(function (variantOption) {
                    var matches = productOptions[optionsIndex].currentVariant.options.forEach(function (currentOption) {
                        if (currentOption.fieldName === variantOption.fieldName && currentOption.valueId === variantOption.valueId) {
                            matchCount++;
                            if (variantOption.fieldName === clickedFieldName) {
                                clickedMatchCount++;
                            }
                        }
                    });
                });
                rankingList.push({ variant: variant, matchCount: matchCount, clickedMatchCount: clickedMatchCount });
            });
            // Sort the ranking list. We're favoring the variants where a clicked field matches.
            rankingList.sort(function (a, b) {
                if (b.clickedMatchCount !== a.clickedMatchCount) return b.clickedMatchCount - a.clickedMatchCount;
                else return b.matchCount - a.matchCount;
            });

            //  Take the first variant from that list and copy all values to our currentVariant object
            productOptions[optionsIndex].currentVariant = {
                variantGuid: rankingList[0].variant.variantGuid,
                variantSku: rankingList[0].variant.variantSku,
                options: []
            };
            rankingList[0].variant.options.forEach(function (option) {
                productOptions[optionsIndex].currentVariant.options.push({
                    fieldName: option.fieldName,
                    valueId: option.valueId,
                    displayValue: option.displayValue
                });
            });
        }
    }

    function findVariant(givenOptions) {
        // find a variant whose options all match the given set of options
        return productOptions[optionsIndex].variants.find(function (variant) {
            return givenOptions.every(function (currentOption) {
                return variant.options.find(function (variantOption) {
                    return variantOption.fieldName === currentOption.fieldName
                        && variantOption.valueId === currentOption.valueId;
                });
            });
        });
    }

    function findCurrentVariant() {
        return productOptions[optionsIndex].variants.find(function (v) {
            return v.variantGuid === productOptions[optionsIndex].currentVariant.variantGuid;
        });
    }

    function displayCurrentVariant(calledFromInit) {
        var variant = findCurrentVariant();
        if (variant) {
            markCurrentOptions(variant.options);
            $(optionsSelector()+" .variant-item-number-itemno").text(variant.itemNumber);
            $(optionsSelector() + " .variant-price").empty().html(variant.price);
            if (variant.price) $(optionsSelector() + " .product-price-text").removeClass("d-none");
            else $(optionsSelector() + " .product-price-text").addClass("d-none");     // hide product price text if there is no price to be displayed
            var productAlertBlack = $(optionsSelector() + " .product-alert-black");
            if (productAlertBlack.length) productAlertBlack.html(variant.productAlert);
            else $(optionsSelector() + " .product-alert-red").html(variant.productAlert);                       
            var smallImageElement = $(optionsSelector() + " .small-variant-image");
            var currentImageUrl = $(smallImageElement).attr("src");
            if (variant.smallVariantImageUrl !== currentImageUrl) {
                $(smallImageElement)
                    .addClass("opacity-05")
                    .one("load", function () { $(this).removeClass("opacity-05"); })
                    .attr("src", variant.smallVariantImageUrl)
                    .attr("width", variant.smallVariantImageWidth)
                    .attr("height", variant.smallVariantImageHeight)
                    .each(function () {
                        // Workaround for situations where the load event doesn't get triggerred because the image is taken from cache, or the
                        // image changes so quickly that our "onload" event didn't have a chance to be set up yet.
                        setTimeout(() => { $(smallImageElement).removeClass("opacity-05"); }, 2000);  // just in case "onload" didn't do it already, we'll clear the opacity class after 2 seconds
                    });
            }
            //$("#cart-quick-edit-modal .quick-edit-variant-image").attr("src", variant.quickEditVariantImageUrl);
            //quickEditModal.displayImage(variant.quickEditVariantImageUrl);
            $(optionsSelector()).data("variantSku", variant.variantSku);
            $(optionsSelector()+" .variant-link").attr("href", variant.variantUrl);
            $(optionsSelector()+" .variant-link").data("variantSku", variant.variantSku);   // this will be used by the GTM click event

            if (!calledFromInit) {
                // Recalculate price total. We don't need to do it on initialization because
                // everything will already be calculated in back-end.
                calculatePriceTotal();
            }

            if (variant.isNew) {
                $(optionsSelector() + " .new-marker").removeClass("d-none");
            } else {
                $(optionsSelector() + " .new-marker").addClass("d-none");
            }

            if (productOptions[optionsIndex].refreshOtherComponentsWhenVariantChanges) {
                $(".dynamic-product-description").html(variant.variantDescription);
                urlUtils.pushParamIntoLink("v", variant.variantSku);
                mediaGallery.displayVariantImages(1, variant.variantImageId, variant.additionalVariantImages);
                productDetailsAndDimensions.displayVariantData(variant.variantSku);
                displayAccessories(variant.variantSku);
                displayProductsInSet(variant.variantSku);
                replacementParts.display(variant.variantSku);
            }

            dispatchEvent("variantChanged", variant);
        }
    }

    function dispatchEvent(eventName, eventData, eventElement) {
        var event;
        var trueTypeOf = function (obj) {
            return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
        };
        if (trueTypeOf(window.CustomEvent) === 'function') {
            event = new CustomEvent(eventName, {
                bubbles: true,
                detail: eventData
            });
        } else {
            event = document.createEvent('CustomEvent');
            event.initCustomEvent(eventName, true, false, eventData);
        }
        if (!eventElement) eventElement = $(optionsSelector());
        eventElement[0].dispatchEvent(event);
        $('.swiper-lazy-preloader').hide();
    }

    function quantityChanged(event) {
        optionsIndex = $(this).closest(allProductOptionsSelector).data("optionsIndex");
        calculatePriceTotal();
    }

    function calculatePriceTotal() {
        var variant = findCurrentVariant();
        var priceTotalSpinner = optionsSelector() + " .price-total-wrapper .spinner-wrapper";
        spinner.show(priceTotalSpinner);
        var priceTotal = $(optionsSelector() + quantityInputSelector).val() * variant.priceDecimal;
        $(optionsSelector() + " .price-total").data("priceTotal", priceTotal);
        spinner.hide(priceTotalSpinner, function () {
            // Doing this in the callback, so the new price is displayed when the spinner is hidden, and not before.
            // That looks better than showing the new value while the spinner is still spinning (because it spins for minimum of 0.5 seconds).
            $(optionsSelector() + " .price-total").html(formatter.money(priceTotal, true));
        });
        dispatchEvent("priceTotalChanged");
    }

    function displayAccessories(variantSku) {
        $(".product-accessories .product-options[data-related-to-variant-sku!='']").addClass("d-none");
        $(".product-accessories .product-options[data-related-to-variant-sku='" + variantSku + "']").removeClass("d-none");
        if ($(".product-accessories .product-options:not(.d-none)").length) {
            // there are some accessories displayed - display the title too
            $(".product-accessories-title").removeClass("d-none");
        }
        else {
            // there aren't any accessories displayed - hide the title too
            $(".product-accessories-title").addClass("d-none");
        }
    }

    function displayProductsInSet(variantSku) {
        var swiperContainer = $('.product-tile[data-tile-type="ProductsInSet"]').closest(".swiper-container");  
        var showedContainer = false;
        $('.product-tile[data-tile-type="ProductsInSet"]').each(function () { $(this).closest(".swiper-slide").hide() });        
        showFilteredProductsInSet('.product-tile[data-tile-type="ProductsInSet"][data-related-to-variant-sku=""]', showedContainer, swiperContainer);
        showFilteredProductsInSet('.product-tile[data-tile-type="ProductsInSet"][data-related-to-variant-sku="' + variantSku + '"]', showedContainer, swiperContainer);
       
        var emptySwiper = true;        
        $(swiperContainer).find(".swiper-slide").each(function () {
            if ($(this).css('display') != 'none')
                emptySwiper = false;
        })

        if (emptySwiper)
            $(swiperContainer).hide();        
    }

    function showFilteredProductsInSet(selector, showedContainer, swiperContainer) {
        $(selector).each(function () {
            if (!showedContainer) { $(swiperContainer).show(); showedContainer = true; }
            showFilteredSlides(this);
        });
    }

    function showFilteredSlides(el) {
        $(el).removeClass("d-none");
        $(el).closest(".swiper-slide").show();
        updateSwiper(el);
    }

    function updateSwiper(el) {
        var productsSwiper = $(el).closest(".swiper-container")[0].swiper;
        if (productsSwiper)
            productsSwiper.update();
    }

    var itemsWithoutPrice = [];
    function checkIfItemHasPrice(childElement) {
        var poElement = productOptionsElement(childElement);
        if (poElement) {
            if ($(poElement).find(".variant-price").text()) return;  // it's okay, it has a price
            // no price, put the item into the array of bad items
            itemsWithoutPrice.push($(poElement).find(".variant-link").text());
        }
    }

    function getQuantity(childElement) {
        var poElement = productOptionsElement(childElement);
        if (poElement) {
            return +$(poElement).find(quantityInputSelector).val();    // unary operator "+" is here to convert the value from string to number
        }
        return null;
    }

    function setQuantity(childElement, quantity, triggerChange) {
        var poElement = productOptionsElement(childElement);
        if (poElement) {
            var quantityInputElement = $(poElement).find(quantityInputSelector);
            if (quantityInputElement) {
                Coria.setQuantity(quantityInputElement, quantity, triggerChange);
            }
        }
    }

    function getVariantSkus(childElement) {
        var poElement = productOptionsElement(childElement);
        if (poElement) {
            var poIndex = $(poElement).data("optionsIndex");
            if (poIndex) {
                return {
                    productSku: productOptions[poIndex].productSku,
                    variantSku: productOptions[poIndex].currentVariant.variantSku
                };
            }
        }
        return { productSku: null, variantSku: null };
    }

    function addToCartClicked(event) {
        itemsWithoutPrice = [];
        optionsIndex = $(this).closest(allProductOptionsSelector).data("optionsIndex");
        var spinnerSelector = optionsSelector() + " .spinner-wrapper";
        var quantity = getQuantity(this);
        if (quantity != 0) {
            checkIfItemHasPrice(this);
            if (itemsWithoutPrice.length) {
                alertMessage.error(CP.Messages["Add To Cart/No Price For Product"], null, false);
            }
            else {
                var skus = getVariantSkus(this);
                addToCart(
                    [{
                        ProductSku: skus.productSku,
                        VariantSku: skus.variantSku,
                        Quantity: quantity
                    }],
                    spinnerSelector
                );
            }
        }
    }

    function addAllToCart(listSelector, spinnerSelector) {
        itemsWithoutPrice = [];
        var addToCartButtons = $(listSelector + " button.cart");
        if (addToCartButtons.length) {
            var itemList = [];
            addToCartButtons.each(function (index, element) {
                var quantity = getQuantity(element);
                if (quantity != 0) {
                    checkIfItemHasPrice(element);
                    var skus = getVariantSkus(element);
                    itemList.push({
                        ProductSku: skus.productSku,
                        VariantSku: skus.variantSku,
                        Quantity: quantity
                    });
                }
            });

            if (itemsWithoutPrice.length) {
                alertMessage.error(CP.Messages["Add To Cart/No Price For Product Plural"] + itemsWithoutPrice.join(", "), null, false);
            }
            else {
                addToCart(
                    itemList,
                    spinnerSelector
                );
            }
        }

    }


    function addToCart(itemList, spinnerSelector) {
        if (itemList.length === 0) return;

        var postData = {
            itemList: itemList
        };
        formUtils.useToken(postData);

        spinner.show(spinnerSelector);

        $.ajax({
            type: "POST",
            url: "/customapi/Order/AddToCart",
            dataType: "json",
            data: postData,
            success: function (data) {
                if (data.status === "OK") {
                    shoppingCartIcon.updateItemCount(data.cartItems);
                    miniCart.flash();
                    //gtmHelper.processCartChanges(data.changedCartItems);     Google Tag Manager is not used
                } else if (data.status === "ERROR") {
                    alertMessage.error(data.message);
                }
            },
            error: function (jq, status, errorThrown) {
                alertMessage.error(status + ": " + errorThrown);
            },
            complete: function () {
                spinner.hide(spinnerSelector);
            }

        });

    }

    return {
        init: init,
        addAllToCart: addAllToCart,
        getVariantSkus: getVariantSkus,
        getQuantity: getQuantity,
        setQuantity: setQuantity
    };
});

